/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Name_LabelInputs */



/**
* | output |
* | --- |
* | "Preset name" |
*
* @param {Standards_Preset_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_name_label = /** @type {((inputs?: Standards_Preset_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "de") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "es") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Preset name")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Preset name")
	return /** @type {LocalizedString} */ ("Preset name")
});